export const isNumber = (value: string | number): value is number =>
  value != null && value !== '' && !isNaN(Number(value.toString()));
